export interface ComparisonPlan {
  id: string;
  insurer: string;
  planName: string;
  premiumMonthly: number;
  sumAssured: string;
  claimRatio: string;
  waitingPeriod: string;
  roomRent: string;
  cashlessHospitals: number;
  maternity: string;
  preExisting: string;
  dayCare: string;
  ambulance: string;
  organDonor: string;
  addOns: string[];
  rating: number;
}

export const comparisonPlans: ComparisonPlan[] = [
  {
    id: "star-comprehensive",
    insurer: "Star Health",
    planName: "Comprehensive Insurance",
    premiumMonthly: 1250,
    sumAssured: "₹10 Lakhs",
    claimRatio: "94.2%",
    waitingPeriod: "30 days",
    roomRent: "No Sublimit",
    cashlessHospitals: 14000,
    maternity: "Covered",
    preExisting: "After 3 years",
    dayCare: "All procedures",
    ambulance: "Covered",
    organDonor: "Covered",
    addOns: ["OPD Cover", "Critical Illness", "Personal Accident"],
    rating: 4.5,
  },
  {
    id: "icici-optima",
    insurer: "ICICI Lombard",
    planName: "Complete Health Insurance",
    premiumMonthly: 1180,
    sumAssured: "₹10 Lakhs",
    claimRatio: "96.8%",
    waitingPeriod: "15 days",
    roomRent: "2% of SI/day",
    cashlessHospitals: 8500,
    maternity: "Covered (after 2 yrs)",
    preExisting: "After 2 years",
    dayCare: "527 procedures",
    ambulance: "Covered",
    organDonor: "Covered",
    addOns: ["Critical Illness", "Hospital Cash", "Maternity Benefit"],
    rating: 4.7,
  },
  {
    id: "niva-reassure",
    insurer: "Niva Bupa (Max)",
    planName: "ReAssure 2.0",
    premiumMonthly: 1350,
    sumAssured: "₹10 Lakhs",
    claimRatio: "90.7%",
    waitingPeriod: "30 days",
    roomRent: "No Sublimit",
    cashlessHospitals: 10500,
    maternity: "Covered",
    preExisting: "After 3 years",
    dayCare: "All procedures",
    ambulance: "Covered",
    organDonor: "Covered",
    addOns: ["Accident Cover", "OPD Cover", "International Coverage"],
    rating: 4.6,
  },
  {
    id: "hdfc-ergo",
    insurer: "HDFC ERGO",
    planName: "Optima Secure",
    premiumMonthly: 1420,
    sumAssured: "₹10 Lakhs",
    claimRatio: "97.5%",
    waitingPeriod: "30 days",
    roomRent: "No Sublimit",
    cashlessHospitals: 13000,
    maternity: "Not Covered",
    preExisting: "After 4 years",
    dayCare: "All procedures",
    ambulance: "Covered",
    organDonor: "Covered",
    addOns: ["Critical Illness", "Maternity Rider", "Hospital Cash"],
    rating: 4.4,
  },
  {
    id: "care-supreme",
    insurer: "Care Health",
    planName: "Supreme Plan",
    premiumMonthly: 1100,
    sumAssured: "₹10 Lakhs",
    claimRatio: "93.5%",
    waitingPeriod: "30 days",
    roomRent: "1% of SI/day",
    cashlessHospitals: 16500,
    maternity: "Covered (after 4 yrs)",
    preExisting: "After 4 years",
    dayCare: "All procedures",
    ambulance: "Covered",
    organDonor: "Covered",
    addOns: ["OPD Cover", "International", "Critical Illness"],
    rating: 4.3,
  },
  {
    id: "tata-medicare",
    insurer: "Tata AIG",
    planName: "Medicare Premier",
    premiumMonthly: 1280,
    sumAssured: "₹10 Lakhs",
    claimRatio: "95.1%",
    waitingPeriod: "30 days",
    roomRent: "No Sublimit",
    cashlessHospitals: 7200,
    maternity: "Covered",
    preExisting: "After 3 years",
    dayCare: "All procedures",
    ambulance: "Covered",
    organDonor: "Covered",
    addOns: ["OPD", "Dental", "Personal Accident"],
    rating: 4.5,
  },
];

export const comparisonFilters = [
  { id: "sum-assured", label: "Sum Assured", options: ["₹5 Lakhs", "₹10 Lakhs", "₹15 Lakhs", "₹25 Lakhs", "₹50 Lakhs"] },
  { id: "insurer", label: "Insurer", options: ["All Insurers", "Star Health", "ICICI Lombard", "Niva Bupa", "HDFC ERGO", "Care Health", "Tata AIG"] },
  { id: "age", label: "Age", options: ["18-30", "31-40", "41-50", "51-60", "60+"] },
  { id: "coverage", label: "Coverage Type", options: ["Individual", "Family Floater", "Senior Citizen", "Maternity"] },
];

export const comparisonFeatures = [
  { key: "premiumMonthly", label: "Monthly Premium" },
  { key: "sumAssured", label: "Sum Assured" },
  { key: "claimRatio", label: "Claim Settlement Ratio" },
  { key: "waitingPeriod", label: "Waiting Period" },
  { key: "roomRent", label: "Room Rent Limit" },
  { key: "cashlessHospitals", label: "Cashless Hospitals" },
  { key: "maternity", label: "Maternity Cover" },
  { key: "preExisting", label: "Pre-Existing Diseases" },
  { key: "dayCare", label: "Day Care Procedures" },
  { key: "ambulance", label: "Ambulance Cover" },
  { key: "organDonor", label: "Organ Donor Expenses" },
  { key: "addOns", label: "Available Add-ons" },
];